import script from "./Registration.vue?vue&type=script&setup=true&lang=js"
export * from "./Registration.vue?vue&type=script&setup=true&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=54ad78f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ad78f9"]])

export default __exports__